import { PAY_NOW_SUCCESS } from 'actions/checkout'
import { LOGIN_SUCCESS } from 'actions/login'
import { LOGOUT_SUCCESS } from 'actions/logout'
import {
  DISMISS_ERROR,
  FETCH_RADIOS_SUCCESS,
  FETCH_RADIOS_FAILURE,
  FETCH_RADIOS_REQUEST,
  SET_FOCUSED_POSITION,
  SET_FOCUSED_GENRE
} from 'actions/radios'

const INITIAL_STATE = {
  isReady: false,
  isFetching: false,
  hasError: false,
  errorMessage: '',
  lastUpdated: -1,
  focusedPosition: 0,
  genres: {},
  byId: {},
  focusedGenre: '',
  focusedPosition: {}
}

const radiosReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RADIOS_REQUEST:
      return {
        ...state,
        isFetching: true,
        hasError: false,
        errorMessage: ''
      }
    case FETCH_RADIOS_SUCCESS:
      let newFocusedGenre = ''
      let newFocusedPosition = {}
      Object.keys(action.payload.genres).forEach(
        (genre, index) => {
          if (index === 0) {
            newFocusedGenre = genre
          }
          newFocusedPosition[genre] = 0
        }
      )
      return {
        ...state,
        isReady: true,
        isFetching: false,
        lastUpdated: Date.now(),
        genres: action.payload.genres,
        byId: action.payload.radios,
        focusedGenre: newFocusedGenre,
        focusedPosition: newFocusedPosition
      }
    case FETCH_RADIOS_FAILURE:
      return {
        ...state,
        isReady: true,
        isFetching: false,
        hasError: true,
        errorMessage: action.payload.message,
        lastUpdated: Date.now()
      }

    case SET_FOCUSED_GENRE:
      return {
        ...state,
        focusedGenre: action.payload.genre
      }
    case SET_FOCUSED_POSITION:
      return {
        ...state,
        focusedPosition: {
          ...state.focusedPosition,
          [action.payload.genre]: action.payload.position
        }
      }

    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case PAY_NOW_SUCCESS:
    case DISMISS_ERROR:
      return {
        ...INITIAL_STATE
      }

    default:
      return state
  }
}

export default radiosReducer
